var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("faq-tab-loader")
    : _c(
        "div",
        { attrs: { id: "faq-container" } },
        [
          _vm.settingsType === "brokerage-settings"
            ? _c("override-customizations", {
                attrs: { page: "faq", size: "col-12" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card" },
            [
              _c(
                "b-row",
                {
                  staticClass: "justify-content-center",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "nav-tabs-wrapper bb-0",
                        staticStyle: { overflow: "visible !important" },
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "nav nav-tabs scroll-container" },
                          _vm._l(_vm.categories, function (category, index) {
                            return _c(
                              "li",
                              {
                                key: category + "-" + index,
                                staticClass: "nav-item w-100",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "nav-link p-1 thin tiny-f clickable",
                                    class: {
                                      active: _vm.currentCategory === category,
                                    },
                                    attrs: { id: category + "-tab" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleChangeTab(category)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.tabTitle(category)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-content px-5 pb-5 pt-3",
                  attrs: { id: "config-questions" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-xl-5 px-3" },
                    [
                      _vm._l(_vm.currentFaq, function (faq, index) {
                        return _c(
                          "b-row",
                          {
                            key: faq.category + "-" + index,
                            staticClass:
                              "justify-content-center align-items-center mb-4",
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12", lg: "9" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { cols: "11" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: faq.question,
                                              expression: "faq.question",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form settings-questions",
                                          attrs: {
                                            id: "question-" + index,
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "settings.faqTab.question"
                                            ),
                                          },
                                          domProps: { value: faq.question },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                faq,
                                                "question",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "question-" + index,
                                              hidden: "",
                                            },
                                          },
                                          [_vm._v("Question")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "1" } },
                                      [
                                        index > 0
                                          ? _c("inline-prompt", {
                                              staticStyle: {
                                                "font-size": "0.8rem",
                                              },
                                              attrs: {
                                                "action-type": "delete",
                                                placement: "right",
                                              },
                                              on: {
                                                accept: function ($event) {
                                                  return _vm.handleDeleteQuestion(
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "11" } }, [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: faq.answer,
                                            expression: "faq.answer",
                                          },
                                        ],
                                        staticClass: "form-control form",
                                        attrs: {
                                          id: "answer-" + index,
                                          maxlength: "500",
                                          placeholder: _vm.$t(
                                            "settings.faqTab.answer"
                                          ),
                                          cols: "78",
                                          rows: "6",
                                        },
                                        domProps: { value: faq.answer },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              faq,
                                              "answer",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "answer-" + index,
                                            hidden: "",
                                          },
                                        },
                                        [_vm._v("Answer")]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-row justify-content-end mt-3",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "add-question clickable",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAddQuestion()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "+ " +
                                  _vm._s(
                                    _vm.$t("settings.faqTab.addAnotherQuestion")
                                  )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }